



















import { Invoice } from '@accounting/interfaces/invoice';
import { PaymentMethod } from '@accounting/interfaces/payment-method';
import { ShoppingCartResponse } from '@accounting/interfaces/shopping-cart';
import BPCStripeService from '@accounting/services/bpc-stripe-api.service';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import InvoiceShoppingCartWizardPreviewStep from './invoice-shopping-cart-wizard-preview-step.vue';
import ShoppingCartWizardPaymentMethodStep from './shopping-cart-wizard-payment-method-step.vue';
import BlockingOverlay from '@shared/components/overlay/blocking-overlay.vue';
import PaymentCheckoutStatus from '@accounting/components/payment-checkout-status.vue';

@Component({
  name: 'bpc-invoice-shopping-cart-wizard',
  components: {
    'bpc-shopping-cart-wizard-payment-method-step': ShoppingCartWizardPaymentMethodStep,
    'bpc-invoice-shopping-cart-wizard-preview-step': InvoiceShoppingCartWizardPreviewStep,
    'bc-overlay-blocking': BlockingOverlay,
    'bpc-payment-checkout-status': PaymentCheckoutStatus,
  },
})
export default class InvoiceShoppingCartWizard extends Vue {
  @Prop({ type: String, default: 'invoice-preview' }) readonly step: string;
  @Prop({ type: String }) readonly invoiceToken: string;
  invoice: Invoice = null;
  selectedPaymentMethod: PaymentMethod = null;
  paymentResponse: ShoppingCartResponse = null;
  isPopupOpen: boolean = false;
  paymentId: number = null;
  paymentStatus: string = null;

  get totalPrice(): number {
    return this.invoice.total_amount;
  }

  get balance(): number {
    return this.invoice.balance;
  }

  get isFree(): boolean {
    return false; // TODO implement free invoices if needed
  }

  get showMoneyTransferInfo(): boolean {
    return (
      this.step === 'confirmation' &&
      this.paymentResponse.paymentMethod.provider === 'money_transfer'
    );
  }

  get showStatus(): boolean {
    return this.showMoneyTransferInfo || this.showPayFipPaymentInfo;
  }

  get showPayFipPaymentInfo(): boolean {
    return this.step === 'confirmation' && this.paymentResponse.paymentMethod.provider === 'payfip';
  }

  get status(): string {
    if (this.showMoneyTransferInfo) {
      return 'success-money-transfer';
    } else if (this.showPayFipPaymentInfo) {
      if (this.paymentStatus === 'success') return 'success-invoice';
      if (this.paymentStatus === 'failed') return 'cancel-invoice';
      return 'ongoing-payfip';
    }
    return '';
  }

  onInvoiceCheckout(invoice: Invoice) {
    this.invoice = invoice;
    this.$emit('step-change', 'payment-method');
  }

  async onPaymentMethodSelected(selectedPaymentMethod: PaymentMethod) {
    this.selectedPaymentMethod = selectedPaymentMethod;
    await this.sendPayment();
    this.$emit('step-change', 'confirmation');
  }

  async sendPayment() {
    const bpcStripe = new BPCStripeService();
    const paymentMethod = {
      ...this.selectedPaymentMethod,
      success_url: this.$clientRouter.getFullClientUrl(
        `payment-invoice-success/${this.invoiceToken}`,
      ),
      cancel_url: this.$clientRouter.getFullClientUrl(
        `payment-invoice-cancel/${this.invoiceToken}`,
      ),
    };
    this.paymentResponse = await bpcStripe.getStripeInvoiceCheckout(paymentMethod, this.invoice.id);
    if (this.paymentResponse.paymentMethod.provider !== 'money_transfer') {
      // NOTE Maybe instead of checking directly money transfer we could add a
      // property in the response if we have the need of this behaior in future
      // payment methods
      this.paymentId = this.paymentResponse.paymentId;
      const urlRedirect = this.paymentResponse.response.redirectUrl;
      if (this.paymentResponse.response.openInAPopUp) {
        const popup = window.open(
          urlRedirect,
          '_blank',
          'height=700, width=900,toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, directories=no, status=no',
        );
        if (popup) {
          this.isPopupOpen = true;
          const focusPopup = () => {
            if (!popup.closed) {
              popup.focus();
            }
          };

          window.addEventListener('click', focusPopup);
          const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkPopupClosed);
              window.removeEventListener('click', focusPopup);
              this.isPopupOpen = false;
            }
          }, 500);
          this.checkPaymentStatus(this.paymentId);
        }
      } else {
        window.location.href = urlRedirect;
      }
    }
  }

  checkPaymentStatus(paymentId: number) {
    this.$bpcEcho
      .getOnlinePaymentStatusChannel(paymentId)
      .listen('.BPC\\Accounting\\Events\\OnlinePaymentSuccess', async data => {
        this.$bpcEcho.leaveOnlinePaymentStatusChannel(this.paymentId);
        this.paymentStatus = 'success';
      })
      .listen('.BPC\\Accounting\\Events\\OnlinePaymentFailed', async data => {
        this.$bpcEcho.leaveOnlinePaymentStatusChannel(this.paymentId);
        this.paymentStatus = 'failed';
      });
  }

  goToStep(step: string) {
    this.$emit('step-change', step);
  }
}
